import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function DashboardQueriesLentasCard() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/monitoramento/resumo`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const formatarData = (data) => {
    if (!data) return "-";
    const d = new Date(data);
    return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow p-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="h-8 bg-gray-200 rounded w-1/2 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-12 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-white rounded-xl shadow p-6">
        <p className="text-gray-500">Erro ao carregar monitoramento</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow overflow-hidden">
      {/* Header com métricas */}
      <div className="p-6 border-b">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-800">Queries Lentas</h3>
          <button
            onClick={() => navigate("/monitoramento/queries-lentas")}
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            Ver todas →
          </button>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-amber-600">{data.totalUltimaHora}</p>
            <p className="text-xs text-gray-500">Última hora</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-blue-600">{data.totalHoje}</p>
            <p className="text-xs text-gray-500">Hoje</p>
          </div>
          <div className="text-center">
            <p className={`text-2xl font-bold ${data.bloqueiosAtivos > 0 ? "text-red-600" : "text-green-600"}`}>
              {data.bloqueiosAtivos}
            </p>
            <p className="text-xs text-gray-500">Bloqueios</p>
          </div>
        </div>
      </div>

      {/* Lista das últimas 5 */}
      <div className="divide-y">
        {data.ultimas?.length === 0 ? (
          <div className="p-6 text-center text-gray-500">
            <svg className="w-12 h-12 mx-auto mb-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p>Nenhuma query lenta recente</p>
          </div>
        ) : (
          data.ultimas?.map((query) => (
            <div
              key={query.id}
              className="px-6 py-3 hover:bg-gray-50 cursor-pointer"
              onClick={() => navigate(`/monitoramento/queries-lentas?filtro=${query.id}`)}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-gray-800">
                      {query.loginName || "Desconhecido"}
                    </span>
                    <span className="px-2 py-0.5 text-xs rounded bg-gray-100 text-gray-600">
                      {query.command}
                    </span>
                    {query.temBloqueio && (
                      <span className="px-2 py-0.5 text-xs rounded bg-red-100 text-red-600">
                        Bloqueio
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 truncate font-mono mt-1">
                    {query.queryTextResumo || "-"}
                  </p>
                </div>
                <div className="text-right ml-4">
                  <p className={`text-sm font-semibold ${
                    query.totalElapsedSeconds > 60 ? "text-red-600" : "text-amber-600"
                  }`}>
                    {query.tempoFormatado}
                  </p>
                  <p className="text-xs text-gray-400">{formatarData(query.dataCaptura)}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}